<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Risk Controls Definition</h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">

    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <div class="card-body">
    <div class="row">
      <div class="col-12 mb-3" *ngIf="app.account.company_hierarchy_of_controls_url">
        <img
          [src]="app.account.company_hierarchy_of_controls_url"
          class="img-fluid border rounded"
          alt="Hierarchy of Controls Image" />
      </div>
    </div>
  </div>
</mat-dialog-content>
